import React from 'react';

import { Box, Stack } from '@mui/material';

import { useInspectorDrawerOpen } from '../documents/editor/EditorContext';

import InspectorDrawer, { INSPECTOR_DRAWER_WIDTH, InspectorDrawerTabsBar } from './InspectorDrawer';
import TemplatePanel from './TemplatePanel';

interface AppProps {
  headerSlot?: React.ReactNode;
}

export default function App({ headerSlot }: AppProps) {
  const inspectorDrawerOpen = useInspectorDrawerOpen();
  const splitHeader = Boolean(headerSlot) && inspectorDrawerOpen;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {headerSlot && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0,
            alignItems: 'center',
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              px: 2,
              py: 0.75,
            }}
          >
            {headerSlot}
          </Box>
          {splitHeader && (
            <Box
              sx={{
                width: INSPECTOR_DRAWER_WIDTH,
                flexShrink: 0,
                alignSelf: 'stretch',
                display: 'flex',
                alignItems: 'center',
                borderLeft: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
              }}
            >
              <InspectorDrawerTabsBar embedded />
            </Box>
          )}
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Stack
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflow: 'hidden',
          }}
        >
          <TemplatePanel />
        </Stack>

        <InspectorDrawer showTabs={!splitHeader} />
      </Box>
    </Box>
  );
}
